module.exports = __webpack_public_path__ + "img/model.0bc8a50d.svg";